<template>
  <div>
    <!-- 节日设置弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="节日设置"
      :visible.sync="fivstDialogVisible"
      :before-close="fivstHandleClose"
      width="47.8%"
      center
    >
      
      <div class="scenicBtn">
        <el-button type="primary" plain @click="addFivestFn()">
          <i class="iconfont icon-jiahao"></i>
          添加节日
        </el-button>
      </div>
      <div class="pxDialog">
        <el-table
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column prop="name" label="节日名称"></el-table-column>
          <el-table-column prop="name" label="开始时间"></el-table-column>
          <el-table-column prop="name" label="结束时间"></el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #FF4D4F;">删除</el-button>
              <el-button type="text" @click="addFivestFn(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共几条记录，</span>
        <span class="demonstration">当前显示第几页</span>
        <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
      </div>
      <!-- 分页结束 -->
      <!-- <div class="btn">
        <el-button>恢复</el-button>
        <el-button class="btnL">确认排序</el-button>
      </div>-->
    </el-dialog>
    <!-- 节日设置弹框结束 -->

    <!-- 添加节日弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="fivstTitle"
      :visible.sync="addFivstDialogVisible"
      :before-close="addFivstHandleClose"
      width="21.8%"
      center
      top="30vh"
    >
      
      <div class="addFivstFrom">
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="节日名称:">
            <el-input v-model="form.name" placeholder="请输入节日名称"></el-input>
          </el-form-item>
          <el-form-item label="节日开始时间:">
            <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="节日结束时间:">
            <el-date-picker v-model="value1" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加节日弹框结束 -->
    <!-- 短信设置弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="短信设置"
      :visible.sync="noteSetDialogVisible"
      :before-close="noteSetHandleClose"
      width="39.6%"
      center
    >
      
      <div class="noteMObile">
        <div class="noteMObileOne">
          <div>
            <span>短信模板内容</span>
            <span>(使用中)</span>
          </div>
          <div>{{NoteSet.Sms}}</div>
        </div>
        <div class="noteMObileTwo">
          <div>
            <span>新短信模板内容</span>
            <span>({{NoteSet.ExamineSmsStatus=='1'?'审核成功':NoteSet.ExamineSmsStatus=='2'?'待审核':'未通过审核'}})</span>
          </div>
          <div>
            <el-input
              type="textarea"
              :autosize="{ minRows: 6, maxRows: 10}"
              v-model="ExamineSms"
              placeholder="请输入新短息模板内容"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="noteFrom">
        <el-form ref="form" :model="form" >
          <div class="notetitle">
            <span>系统余额提醒设置</span>
            <span>注:</span>
            <span>频次限制默认3次/天,计时默认结束三天前提醒,设置不得大于6</span>
          </div>
          <el-form-item label="首次提醒额度:">
            <span class="xingA">*</span>
            <el-input v-model="NoteSet.fbalance" placeholder="数量"></el-input>
            <span class="Left5">元</span>
          </el-form-item>
          <el-form-item label="最低提醒额度:">
            <span class="xingA">*</span>
            <el-input v-model="NoteSet.lbalance" placeholder="数量"></el-input>
            <span class="Left5">元</span>
          </el-form-item>
          <el-form-item label="频次限制:">
            <span class="xingB">*</span>
            <el-input v-model="NoteSet.frequency" placeholder="数量"></el-input>
            <span class="Left5">次/天</span>
          </el-form-item>
          <el-form-item label="景区微商城是否发送短信:">
            <el-radio-group v-model="NoteSet.sms_flag">
              <el-radio label="1">发送</el-radio>
              <el-radio label="2">不发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="settings">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 短信设置弹框结束 -->
    <!-- 基本信息弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="基本信息"
      :visible.sync="infoSetDialogVisible"
      :before-close="infoSetHandleClose"
      width="84.5%"
      center
    >
      <div class="infoFrom">
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <div class="infoTwo">
            <el-form-item label="景区logo:" prop="WebSiteLOGO">
              <div class="logo_img">
                <!-- <el-upload
                  class="avatar-uploader"
                  action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :data="datas">
                  <img v-if="form.WebSiteLOGO" :src="form.WebSiteLOGO" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                  </i>
                </el-upload> -->
                <div class="flexs_upload">
                  <cutImageDialog :imgs="form.WebSiteLOGO" @resurl="resurl"  v-if="flag" />
                </div>  
              </div>
              <div>
                <span>注:</span>
                <span>请上传1M以下的图片(此图片用于平台宣传,请认真对待),支持png,jpg,jpeg</span>
              </div>
            </el-form-item>
            <el-form-item label="微信二维码:" prop="WebSiteLOGO">
              <div class="infoTwo logo_img">
                <el-upload
                  class="avatar-uploader"
                  action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                  :show-file-list="false"
                  :on-success="handleWeChat"
                  :data="datas">
                  <img v-if="form.WeChatCode" :src="form.WeChatCode" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon">
                  </i>
                </el-upload>
              </div>
              <div>
                <span>注:</span>
                <span>请上传1M以下的图片(此图片用于平台宣传,请认真对待),支持png,jpg,jpeg</span>
              </div>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="景区简介:" prop="introduction">
              <quill-editor 
                v-model="form.introduction" 
                ref="myQuillEditor" 
               >
              </quill-editor>
            </el-form-item>
          </div>
          <div class="itemFour">
            <el-form-item label="雪场设备:">
                <div class="facilit">
                  <div v-for="(item,index) in snow_site_facility" :key="index">
                    <el-checkbox v-model="item.check">
                      <span>{{ item.name }}：</span>
                      <el-input placeholder="请输入数量" v-model="item.num" @input="facilityInput(item)"></el-input>
                    </el-checkbox>
                  </div>
                </div>
            </el-form-item>
          </div>
          <div class="itemFour">
            <el-form-item label="雪道情况:">
              <div class="facilit">
                  <div v-for="(item,index) in snow_track_situation" :key="index">
                    <el-checkbox v-model="item.check">
                      <span>{{ item.name }}：</span>
                      <el-input placeholder="请输入数量" v-model="item.num" @input="situationInput(item)"></el-input>
                    </el-checkbox>
                  </div>
                </div>
            </el-form-item>
          </div>
          <div class="itemFour">
            <el-form-item label="雪具租赁:">
              <div class="facilit">
                  <div v-for="(item,index) in snow_gear_rental" :key="index">
                    <el-checkbox v-model="item.check">
                      <span>{{ item.name }}：</span>
                      <el-input placeholder="请输入数量" v-model="item.num" @input="rentalInput(item)"></el-input>
                    </el-checkbox>
                  </div>
                </div>
            </el-form-item>
          </div>
          <div class="itemFive">
            <el-form-item label="服务设施:">
              <div class="servicefacility">
                <div v-for="(item, index) in cities" :key="index" >
                  <el-checkbox-group v-model="form.service_facility">
                    <el-checkbox v-model="item.checked" :label="item.name">{{
                      item.name
                    }}</el-checkbox>
                  </el-checkbox-group>
               </div>
              </div>
            </el-form-item>
          </div>
          <div class="itemFour">
            <el-form-item label="医疗设施:">
              <div class="facilit">
                  <div v-for="(item,index) in medical" :key="index">
                    <el-checkbox v-model="item.check">
                      <span>{{ item.name }}：</span>
                      <el-input placeholder="请输入数量" v-model="item.num" @input="medicalInput(item)"></el-input>
                    </el-checkbox>
                  </div>
                </div>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="交通信息:">
              <!-- <span class="xingB">*</span> -->
              <quill-editor 
                v-model="form.traffic" 
                ref="myQuillEditor" 
               >
            </quill-editor>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="配套特色:">
              <!-- <span class="xingB">*</span> -->
              <quill-editor 
                v-model="form.features" 
                ref="myQuillEditor" 
               >
            </quill-editor>
            </el-form-item>
          </div>
          <div class="itemSex">
            <el-form-item label="雪场宣传图:">
              <div class="infoTwo">
                <el-upload action="http://xwt.softykt.net/api/product/uploadInfoRemit"
              :limit="5"
              :on-success="attachUploadSuccess"
              :data="datas" list-type="picture-card"
              ref="pictureUpload"
              :file-list="fileList">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              </div>
              <div>
                <span>注:</span>
                <span>请上传1M以下的图片(此图片用于平台宣传,请认真对待),支持png,jpg,jpeg</span>
              </div>
            </el-form-item>
          </div>
          <div class="itemSeven">
            <el-form-item label="营业时间:">
                <div style="display: flex; align-items: center; gap: 10px;">
                  <el-time-picker
                    is-range
                    v-model="datime1"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="HH:mm"
                    placeholder="选择时间范围"
                  ></el-time-picker>
                  <span class="hours">(24小时制)</span>
                </div>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="btn">
              <!-- <el-button>清空</el-button> -->
              <el-button class="btnL" @click="basic('form')">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 基本信息弹框结束 -->
    <!-- 群发消息弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="群发消息"
      :visible.sync="massMsgDialogVisible"
      :before-close="massMsgHandleClose"
      width="45.3%"
      center
      top="20vh"
    >
      
      <div class="editMsgFrom">
        <el-form ref="form" :model="form" label-width="140px">
          <div class="itemOne">
            <el-form-item label="[日历票]游玩时间:">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <div class="itemOne">
                <span>注：短信会发送给该使用时间段内的用户</span>
              </div>
            </el-form-item>
            <el-form-item label="期票购买时间:">
              <span style="display:blokc;margin-right:1rem;">当前</span>
              <el-input v-model="days" placeholder="天数"></el-input>
              <span  style="display:blokc;margin-left:1rem;">天前</span>
              <div class="itemOne">
                <span>注：短信会发送给该时段内购买的用户</span>
              </div>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单状态：">
              <el-radio-group v-model="type">
                <el-radio :label="1">全部订单</el-radio>
                <el-radio :label="2">未使用订单</el-radio>
              </el-radio-group>
            </el-form-item>   
          </div>
          <el-form-item label="">
              <div class="reportBtns" @click="reportClick">导出订单联系方式</div>
          </el-form-item>   
          <div>
            <el-form-item label="编辑短信内容:">
              <el-input
                type="textarea"
                :autosize="{ minRows: 9, maxRows: 15}"
                v-model="data.description"
                placeholder="请输入短信内容"
                @change="checkInput"
              ></el-input>
              <div class="itemOne">
                <span>注:</span>
                <span>短信会发送给该使用时间段内的用户,短信最长65个字符，纯英文100字符，超出字符按照两条短信收费</span>
              </div>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="btn">
              <el-button>清空</el-button>
              <el-button class="btnL" @click="btns">确认发送</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 群发消息弹框结束 -->
  </div>
</template>

<script>
import {addQfTemplate, exportMobile , ScenicNoteSet,ScenicUpdateUpParameters,ScenicSetUpParameters,GetScenicNote} from '@/request/scenic.js'
import { Message } from 'element-ui';
import cutImageDialog from '@/assets/place.vue'
export default {
  data() {
    return {
      checkedCities:'',
      fivstDialogVisible: false, // 节日设置
      addFivstDialogVisible: false, // 添加节日
      fivstTitle: "", // 添加节日和编辑弹框标题
      noteSetDialogVisible: false, // 短信设置
      infoSetDialogVisible: false, // 基本信息设置
      massMsgDialogVisible: false, // 基本信息设置
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false, // 图片上传
      checkList: ["复选框 A"],
      cities: [
        { name: "停车场", checked: false },
        { name: "餐厅", checked: false },
        { name: "健身房", checked: false },
        { name: "咖啡厅", checked: false },
        { name: "酒吧", checked: false },
        { name: "游乐场", checked: false },
        { name: "温泉SPA", checked: false },
        { name: "小吃街", checked: false },
        { name: "客房", checked: false },
        { name: "酒店", checked: false },
        { name: "休息厅", checked: false },
        { name: "超市", checked: false },
        { name: "民宿", checked: false },
        { name: "电影院", checked: false },
        { name: "KTV", checked: false },
        { name: '水吧',checked: false},
        { name: '儿童乐园',checked: false}
      ],
      tableData: [
      ],
      form: {
        introduction:'',
        snow_site_facility:{},
        snow_track_situation:{},
        snow_gear_rental:{},
        service_facility:[],
        traffic:'',
        features:'',
        poster1:'',
        poster2:'',
        poster3:'',
        poster4:'',
        poster5:'',
        is_holiday:'0',
        medical_facility:{},
        opentime:'',
        balance:'',
        balancemin:'',
        balanceday:'',
        daytime:'',
        dayendtime:'',
        holidaytime:'',
        holidayendtime:'',
        defaulttime:'',
        defaultendtime:'',
        WebSiteLOGO:'',
        WeChatCode:''
      },
      value1: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        description:'',
        useBeginDate:'',
        useEndDate:''
      },
      NoteSet:{
        token:window.sessionStorage.getItem('Token'),
        ExamineSms:'',
        fbalance:'',
        lbalance:'',
        frequency:'',
        sms_flag:'2'
      },
      days:'',
      type:1,
      snow_site_facility:[
        {
          name:'双人吊椅',
          num:'',
          check:false
        },
        {
          name:'四人吊椅',
          num:'',
          check:false
        },
        {
          name:'六人吊椅',
          num:'',
          check:false
        },
        {
          name:'八人吊椅',
          num:'',
          check:false
        },
        {
          name:'吊箱',
          num:'',
          check:false
        },
        {
          name:'拖牵',
          num:'',
          check:false
        },
        {
          name:'魔毯',
          num:'',
          check:false
        },
      ],
      snow_track_situation:[
        {
          name:'垂直落差',
          num:'',
          check:false
        },
        {
          name:'高级道',
          num:'',
          check:false
        },
        {
          name:'中级道',
          num:'',
          check:false
        },{
          name:'初级道',
          num:'',
          check:false
        },{
          name:'雪圈道',
          num:'',
          check:false
        }
      ],
      snow_gear_rental:[
      {
          name:'双板',
          num:'',
          check:false
        },
        {
          name:'单板',
          num:'',
          check:false
        },
        {
          name:'雪服',
          num:'',
          check:false
        },
        {
          name:'头盔',
          num:'',
          check:false
        }
      ],
      medical:[
        {
          name:'医务人员',
          num:'',
          check:false
        },
        {
          name:'医务室',
          num:'',
          check:false
        },
        {
          name:'救护车',
          num:'',
          check:false
        }
      ],
      datas:{
        token:window.sessionStorage.getItem('Token')
      },
      fileList:[],
      datime1:'',
      infor:'',
      flow:true,
      rules:{
        introduction: { required: true, message: '请输入简介', trigger: 'blur' },
        WebSiteLOGO: [{ required: true, message: '请上传景区logo', trigger: 'change'}],
        WeChatCode: [{ required: true, message: '请上传微信二维码', trigger: 'change'}]
      },
      ExamineSms:'',
      flag:false
    };
  },
  components:{
    cutImageDialog 
  },
  methods: {
    resurl(row){
      this.form.WebSiteLOGO = row
    },
    reportClick(){
      if(this.value1==''){
        Message.error('请选择时间')
        return false
      }
      if(this.days==''){
        Message.error('请输入天数')
        return false
      }
      let data = {
        start_time:this.value1[0],
        end_time:this.value1[1],
        token:window.sessionStorage.getItem('Token'),
        days:this.days,
        type:this.type
      }
      exportMobile(data).then(res=>{
        console.log(res)
        if(res.data.status=='ok'){
          window.location.href = res.data.result.url
        }else{
          Message.error(res.data.msg)
        }
      })
    },
    checkInput(value){
      let len = 0, j = 0; //len为字节数,j为字符数
      for (var i = 0; i < value.length; i++) {
        //charCodeAt(i)返回value第i个的UNcode值
        if (value.charCodeAt(i) > 127 || value.charCodeAt(i) == 94) {
          len += 2;
          j++;
        } else {
          len++;
          j++;
        }
        if (len > 135) {
          Message.error("短信最长65个字符，纯英文100字符，超出字符按照两条短信收费");
          break;
        }
      }
    },
    attachUploadSuccess(response, file, fileList){
      this.fileList = fileList
    },
    // 微信
    handleWeChat(res,file){
      this.form.WeChatCode = res.result
    },
    // 景区logo
    handleAvatarSuccess(res, file) {
      this.form.WebSiteLOGO = res.result
    },
    // 医务设施
    medicalInput(item){
      this.medical.map(itm=>{
        if(itm.name==item.name){
            itm.check = true
        }
      })
    },
    // 雪具租凭
    rentalInput(item){
      this.snow_gear_rental.map(itm=>{
        if(itm.name==item.name){
            itm.check = true
        }
      })
    },
    // 雪道情况
    situationInput(item){
      this.snow_track_situation.map(itm=>{
        if(itm.name==item.name){
            itm.check = true
        }
      })
    },
    // 雪场设备
    facilityInput(item){
      this.snow_site_facility.map(itm=>{
        if(itm.name==item.name){
            itm.check = true
        }
      })
    },
    handleRemove(file) {
      this.$refs.pictureUpload.handleRemove(file)
    },
    basic(form){
      let service_facility = ''
      if(this.form.service_facility){
        this.form.service_facility.map(item=>{
          service_facility += item + ','
        })
        service_facility  = service_facility.substr(0,service_facility.length - 1);
      }
      this.fileList.map((item,index)=>{
        if(!item.response){
          switch(index){
            case 0:
              this.form.poster1 = item.url
                break;
            case 1:
              this.form.poster2 = item.url
                break;
            case 2:
              this.form.poster3 = item.url
                break;
            case 3:
              this.form.poster4 = item.url
                break;
            case 4:
              this.form.poster5 = item.url
                break;
            default:
                break;
          }
        }else{
          switch(index){
            case 0:
              this.form.poster1 = item.response.result
                break;
            case 1:
              this.form.poster2 =  item.response.result
                break;
            case 2:
              this.form.poster3 =  item.response.result
                break;
            case 3:
              this.form.poster4 =  item.response.result
                break;
            case 4:
              this.form.poster5 =  item.response.result
                break;
            default:
                break;
          }
        }
      })
      
      this.snow_site_facility.map(item=>{
        if(item.check){
          this.form.snow_site_facility[item.name] = item.num
        }
      })
      this.snow_track_situation.map(item=>{
        if(item.check){
          this.form.snow_track_situation[item.name] = item.num
        }
      })
      this.snow_gear_rental.map(item=>{
        if(item.check){
          this.form.snow_gear_rental[item.name] = item.num
        }
      })
      this.medical.map(item=>{
        if(item.check){
          this.form.medical_facility[item.name] = item.num
        }
      })
      if(!this.datime1 || !Array.isArray(this.datime1) || this.datime1.length !== 2 || !this.datime1[0] || !this.datime1[1]){
        Message.error('请选择营业时间')
        return false
      }
      // 只使用全部时间的值，节假日和平日也使用相同的值
      this.form.defaulttime = this.datime1[0]
      this.form.defaultendtime = this.datime1[1]
      this.form.holidaytime = this.datime1[0]
      this.form.holidayendtime = this.datime1[1]
      this.form.daytime = this.datime1[0]
      this.form.dayendtime = this.datime1[1]
      this.form.is_holiday = '0' // 固定为全部
      let data = {
        token:window.sessionStorage.getItem('Token'),
        introduction:this.form.introduction,
        snow_site_facility:this.form.snow_site_facility,
        snow_track_situation:this.form.snow_track_situation,
        snow_gear_rental:this.form.snow_gear_rental,
        service_facility:service_facility,
        traffic:this.form.traffic,
        features:this.form.features,
        poster1:this.form.poster1,
        poster2:this.form.poster2,
        poster3:this.form.poster3,
        poster4:this.form.poster4,
        poster5:this.form.poster5,
        is_holiday:'0',   // 固定为全部
        medical_facility:this.form.medical_facility,
        balance:'',
        balancemin:'',
        balanceday:'',
        daytime:this.form.daytime, // 平日（使用全部时间的值）
        dayendtime:this.form.dayendtime,
        holidaytime:this.form.holidaytime, // 节假日（使用全部时间的值）
        holidayendtime:this.form.holidayendtime,
        defaulttime:this.form.defaulttime, // 全部时间
        defaultendtime:this.form.defaultendtime,
        WebSiteLOGO:this.form.WebSiteLOGO,
        WeChatCode:this.form.WeChatCode
      }
      this.$refs[form].validate((valid) => {
          if (valid) {
             if(this.flow){
              ScenicUpdateUpParameters(data).then(res=>{
                if(res.data.status=='ok'){
                  this.infoSetDialogVisible = false
                  Message.success('修改景区基本信息成功')
                  this.$emit('scenic')
                }
              })
            }else{
              ScenicSetUpParameters(data).then(res=>{
                if(res.data.status=='ok'){
                  this.infoSetDialogVisible = false
                  Message.success('添加景区基本信息成功')
                  this.$emit('scenic')
                }
              })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 短信设置确认
    settings(){
      this.NoteSet.token = window.sessionStorage.getItem('Token')
      this.NoteSet.ExamineSms = this.ExamineSms
      ScenicNoteSet(this.NoteSet).then(res=>{
        if(res.data.status=='ok'){
          this.noteSetDialogVisible = false;
          this.$emit('ScenicNot')
          this.$message.success('发送成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 群发短信确认
    btns(){
      if(this.value1){
        this.data.useBeginDate = this.value1[0]
        this.data.useEndDate = this.value1[1]
      }else{
        this.data.useBeginDate = ''
        this.data.useEndDate = ''
      }
      addQfTemplate(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.massMsgDialogVisible = false
          this.$emit('massMsg')
          this.$message.success('发送成功')
        }
      })
    },
    // 群发消息
    editSend() {
      this.massMsgDialogVisible = true;
    },
    // 群发消息X
    massMsgHandleClose() {
      this.massMsgDialogVisible = false;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 基本信息设置：根据必填项是否有值判断新增/更新，有值走更新，没有走新增
    infoSet(infor) {
      this.flag = true
      if(infor){
        const hasRequired = !!(infor.WebSiteLOGO || infor.WeChatCode || (infor.introduction && String(infor.introduction).trim()))
        this.flow = !!hasRequired
        this.form.is_holiday = '0' // 固定为全部
        this.form.WebSiteLOGO = infor.WebSiteLOGO
        this.form.WeChatCode = infor.WeChatCode
        this.form.introduction = infor.introduction
        this.form.traffic = infor.traffic
        this.form.features = infor.features
        if(infor.snow_site_facility){
          var obj1 = JSON.parse(infor.snow_site_facility)
          for(let i in obj1) {
            this.snow_site_facility.map(item=>{
              if(item.name==i){
                item.check = true
                item.num = obj1[i]
              }
            })
          }
        }
        if(infor.snow_track_situation){
          var obj2 = JSON.parse(infor.snow_track_situation)
          for(let i in obj2) {
            this.snow_track_situation.map(item=>{
              if(item.name==i){
                item.check = true
                item.num = obj2[i]
              }
            })
          }
        }
       
        if(infor.snow_gear_rental){
          var obj3 = JSON.parse(infor.snow_gear_rental)
          for(let i in obj3) {
            this.snow_gear_rental.map(item=>{
              if(item.name==i){
                item.check = true
                item.num = obj3[i]
              }
            })
          }
        }
        var img = []
        if(infor.poster1){
        img.push({
            url:infor.poster1
          })
        }
        if(infor.poster2){
        img.push({
            url:infor.poster2
          })
        }
        if(infor.poster3){
        img.push({
            url:infor.poster3
          })
        }
        if(infor.poster4){
        img.push({
            url:infor.poster4
          })
        }
        if(infor.poster5){
        img.push({
            url:infor.poster5
          })
        }
        this.fileList = img
        if(infor.service_facility!=null){
          infor.service_facility.split(',').map(item=>{
            this.form.service_facility.push(item)
          })
        }
        if(infor.medical_facility){
          var obj = JSON.parse(infor.medical_facility)
          for(let i in obj) {
              this.medical.map(item=>{
                if(item.name==i){
                  item.check = true
                  item.num = obj[i]
                }
            })  
          }
        }
        
        // 优先使用全部时间，如果没有则使用节假日或平日时间
        if(infor.defaultendtime&&infor.defaulttime){
          this.datime1 = [infor.defaulttime,infor.defaultendtime]
        }else if(infor.holidaytime&&infor.holidayendtime){
          this.datime1 = [infor.holidaytime,infor.holidayendtime]
        }else if(infor.daytime&&infor.dayendtime){
          this.datime1 = [infor.daytime,infor.dayendtime]
        }
      }else{
        this.flow = false
      }
      this.infoSetDialogVisible = true;
    },
    // 基本信息设置X
    infoSetHandleClose() {
      this.infoSetDialogVisible = false;
      this.flag = false
    },
    // 短息设置
    noteSet() {
      this.noteSetDialogVisible = true;
      this.getListNote()
    },
    getListNote(){
      let data={
        token: window.sessionStorage.getItem("Token"),
      }
      GetScenicNote(data).then(res=>{
        if(res.data.status=='ok'){
          this.ExamineSms = res.data.result.ExamineSms
          this.NoteSet = res.data.result
          this.NoteSet.ExamineSms = res.data.result.ExamineSms
          this.NoteSet.sms_flag +=''
        }
      })
    },
    // 短息设置X
    noteSetHandleClose() {
      this.noteSetDialogVisible = false;
    },
    // 添加节日
    addFivestFn(row) {
      if (row) {
        this.fivstTitle = "编辑节日";
      } else {
        this.fivstTitle = "添加节日";
      }
      this.addFivstDialogVisible = true;
      this.fivstDialogVisible = false;
    },
    // 添加节日X
    addFivstHandleClose() {
      this.addFivstDialogVisible = false;
    },
    // 节日设置
    fivst() {
      this.fivstDialogVisible = true;
    },
    // 节日设置X
    fivstHandleClose() {
      this.fivstDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.editMsgFrom {
  .itemOne {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    // line-height: 20px;
    color: #e74c3c;
    display: flex;
    ::v-deep .el-input{
      width: 12.2rem;
    }
    ::v-deep .el-date-editor{
      width: 26rem;
    }
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 20px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.infoFrom {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -76px;
    color: #ff4d4f;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -76px;
    color: #ff4d4f;
  }
  .el-form {
    width: 55%;
    margin: auto;
  }
  /deep/.el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .infoOne {
    .el-input {
      width: 280px;
    }
  }
  .infoTwo {
    display: flex;
    /deep/.el-form-item__content {
      display: flex;
      > div:nth-child(2) {
        width: 140px;
        height: 80px;
        margin-left: 20px;
        margin-right: 59px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        color: #ff4d4f;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  .itemThree {
    .el-textarea {
      width: 740px;
    }
  }
  .itemFour {
    .el-checkbox-group {
      width: 740px;
      > div {
        // width: 200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > div {
          width: 42%;
          margin-bottom: 5px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .el-input {
          width: 220px;
        }
      }
    }
  }
  .itemFive {
    /deep/.el-checkbox-group {
      width: 740px;
    }
    /deep/.el-checkbox {
      // margin: 16px 0;
      // display: block;
      // line-height: 23px;
      // white-space: normal;
      // margin-right: 0;
      // text-align: left;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
  .itemSex {
    div:nth-child(2) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      margin-top: 7px;
      /* identical to box height */
      text-align: justify;
      color: #ff4d4f;
      > span:nth-child(1) {
        margin-right: 10px;
      }
    }
  }
  .itemSeven {
    .el-form-item {
      margin-bottom: 0px;
    }
    .el-checkbox-group {
      width: 520px;
      // display: flex;
      // justify-content: space-between;
      > div {
        > div {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
        }
      }
    }
    .margR {
      margin-left: -16px;
    }
    .dataSet {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
    }
    .hours {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ff4d4f;
      white-space: nowrap;
    }
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 30px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.noteFrom {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -10px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: 17px;
    color: #e74c3c;
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 10px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    color: #666666;
  }
  .el-input {
    width: 280px;
  }
  > span:nth-child(2) {
    margin-left: 10px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  }
  .notetitle {
    height: 25px;
    margin: 20px 0 16px 0;
    > span:nth-child(1) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      margin-right: 20px;
      color: #000000;
    }
    > span:nth-child(2) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      margin-right: 10px;
      color: #e74c3c;
    }
    > span:nth-child(3) {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */

      color: #e74c3c;
    }
  }
}
/deep/.el-checkbox {
  // margin: 16px 0;
  // display: block;
  // line-height: 23px;
  // white-space: normal;
  // margin-right: 0;
  // text-align: left;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height */
  color: #666666;
}
.noteMObile {
  display: flex;
  height: 200px;
  .noteMObileOne {
    width: 350px;
    margin-right: 20px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #3176ec;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      height: 158px;
      padding: 20px;
      box-sizing: border-box;
      background: #f7f7fa;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: justify;
      color: #000000;
    }
  }
  .noteMObileTwo {
    width: 350px;
    height: 220px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #7ad896;
      }
    }
    > div:nth-child(2) {
      /deep/.el-textarea__inner {
        width: 100%;
        height: 158px;
        padding: 20px;
        box-sizing: border-box;
        background: #f7f7fa;
        border-radius: 4px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        color: #000000;
        border: none;
      }
    }
  }
}
.addFivstFrom {
  /deep/.el-form-item__label {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .el-input {
    width: 280px;
  }
  .btn {
    // margin: 20px 100px 10px 0;
    margin-top: 10px;
    margin-left: -100px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
}
.scenicBtn {
  .el-button {
    margin-top: 10px;
    margin-bottom: 20px;
    width: 120px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    box-sizing: border-box;
    color: #246deb;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 30px auto 20px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
.facilit{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.facilit>div{
  width: 48%;
  display: flex;
  margin-bottom: 2rem;
  // justify-content: space-between;
}
.facilit>div .el-input{
 width:220px;
}
.servicefacility{
  display: flex;
  flex-wrap: wrap;

}


.servicefacility > div {
  margin-bottom: 1rem;
}

.servicefacility > div {
 width: 15%;
}
::v-deep .show{
  width: 14.6rem !important;
  height: 14.6rem !important;
}
.logo_img/deep/ .avatar,.logo_img/deep/.el-upload{
  width: 100%;
  height:100%
}
/deep/  .avatar-uploader{
  background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 146px;
    height: 146px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
  border-color: #409EFF;
  display: flex;
  align-content: center;
    color: #409EFF;
    justify-content: center;
}
.group_holiday /deep/ .el-radio-group{
  display: flex;
  width: 43rem !important;
  justify-content: space-between;
  align-items: center;
}
.group_holiday{
  margin-bottom: 20px;
}
.noteFrom /deep/ .el-form-item__label{
  min-width:10rem;
}
.Left5{
  margin-left: 0.5rem;
}
.reportBtns{
  width: 14rem;
  height: 4rem;
  border-radius: 0.4rem;
  background: #246deb;
  color: #fff;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>